export default __webpack_public_path__ + "static/media/eitaa.8d3bd8ad.png";